import { useMountTransition } from '@farol-ds/react'
import { useCallback, useContext } from 'react'

import { FullscreenModalProps } from '../fullscreen-modal'
import { FullscreenModalContext } from './context'

export type UseFullscreenModalProviderProps = FullscreenModalProps

export interface UseFullscreenModalProviderReturn {
  open: boolean
  isMount: boolean
  onOpenChange: (open: boolean) => void
}

const transitionTime = 300

export function useFullscreenModalProvider(
  props: UseFullscreenModalProviderProps
): UseFullscreenModalProviderReturn {
  const { open: openProp, defaultOpen, onOpenChange: onOpenChangeProp } = props

  const [open, setOpen, isMount] = useMountTransition(transitionTime, defaultOpen, 'backwards', {
    controlledState: openProp,
  })

  const onOpenChange = useCallback<UseFullscreenModalProviderReturn['onOpenChange']>(
    (nextOpen: boolean) => {
      setOpen(nextOpen)
      onOpenChangeProp?.(nextOpen)
    },
    [onOpenChangeProp, setOpen]
  )

  return {
    open,
    isMount,
    onOpenChange,
  }
}

export function useFullscreenModal() {
  const context = useContext(FullscreenModalContext)
  return context
}
